export const SIGN_IN_CONFIGURATION: string = 'account/{accountId}/event/{eventId}/signin-configuration';
